import { Controller } from "@hotwired/stimulus"

// Sits on a routing panel with many channel-select dropdowns for the same
// notification channel. Refetches the channel list once (bypassing the
// server-side cache) and repaints every dropdown's options directly, instead
// of letting each dropdown hit the Slack/Discord API independently.
export default class extends Controller {
  static values = { channelsUrl: String }

  async refresh(event) {
    const button = event.currentTarget
    button.disabled = true

    try {
      const response = await fetch(`${this.channelsUrlValue}?refresh=1`, {
        headers: { "Accept": "application/json" }
      })
      if (!response.ok) throw new Error("refresh failed")
      const channels = await response.json()
      this.#repaint(channels)
      window.toast("Channel list refreshed", { kind: "success" })
    } catch {
      window.toast("Couldn't refresh channel list", { kind: "error" })
    } finally {
      button.disabled = false
    }
  }

  #repaint(channels) {
    this.element.querySelectorAll('select[data-controller~="channel-select"]').forEach((select) => {
      const current = select.value
      Array.from(select.options).forEach((opt) => { if (opt.value) opt.remove() })

      channels.forEach(({ id, name }) => {
        const opt = document.createElement("option")
        opt.value = id
        opt.textContent = `#${name}`
        if (id === current) opt.selected = true
        select.appendChild(opt)
      })
    })
  }
}
